<template>
  <div>
    <div class="aboutUs">
      <div class="section is-medium">
        <div class="container is-fluid">
          <div class="columns">
            <div class="column is-one-quarter">
              <h1 class="deneme">ABOUT US</h1>
            </div>
            <div class="column tile is-parent is-vertical">
              <p class="tile is-child">Today, the impact of rapid changes in technology and economy is also manifested in the field of law. Therefore, these changes bring the necessity for dynamic, open-minded and professionally up-to-date lawyers more than ever. Sarıkaya + Şahin aims to respond to these necessities while enhancing its services to come along with the best possible solutions.</p>
              <p class="tile is-child">Sarıkaya + Şahin focuses on providing high level advice and expertise to its clients for their legal obstacles in various commercial areas in order to materialise their business strategies and assist them to achieve their goals. Sarıkaya + Şahin counsels clients of all types – individuals, entrepreneurs, small businesses and start-ups and international and global entities.</p>
              <p class="tile is-child">By putting forward solution-oriented and interest efficient approaches, Sarıkaya + Şahin is dedicated to provide excellence in client service.</p>
              <p class="tile is-child">In matters of relations with administrative body and institutions, pursuing and concluding licence, authorization and permit procedures, Sarıkaya + Şahin collaborates with Uğur Poyraz Law Firm based in Ankara with 20 years of experience.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <span class="uplogo"><img src="/static/upLogo.png"></span>
  </div>
</template>

<script>

export default {
  name: 'aboutUs',
  data() {
    return {

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.aboutUs p {
  font-size: 1.5rem;
  text-align: justify;
}

#app {
  background: #606c96;
}

.aboutUs h1::after {
  content: "";
  position: absolute;
  height: 5px;
  bottom: 0;
  left: 0;
  width: 40%;
  background: #81A716;
}

.aboutUs h1 {
  position: relative;
  color: #504f50;
}

.uplogo {
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-bottom: 22px;
  padding-bottom: 43px;
}

@media only screen and (max-width: 768px) {
  .uplogo {
    justify-content: center;
    margin-bottom: 100px;
  }
  .aboutUs p {
    font-size: 1.3rem;
  }
  .aboutUs h1 {
    font-size: 25px;
  }
  div.column.is-one-quarter::after {
    content: "";
    position: absolute;
    right: 12%;
    top: 0;
    height: 100%;
    background:unset;
    width: 1px;
  }
}
</style>



// WEBPACK FOOTER //
// aboutus.vue?986376a6